// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    var jHtml = jQuery( 'html' );
    jQuery.extend( true, e4.settings, {
        separatorInteger: ( function () {
            return jHtml.data( 'separatorInteger' ).toString();
        }() ),
        separatorDecimal: ( function () {
            return jHtml.data( 'separatorDecimal' ).toString();
        }() ),
//        ecom: {
//            cart: {
//                updateOrderlineDelay: 500
//            }
//        },
        require: {
            jQueryValidate: {
                test: 'window.jQuery.fn.validate',
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.17.0/jquery.validate.min.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.min.js',
                callback: function () {
                    var getMessages = function ( strLang ) {
                            if ( strLang !== 'en' ) {
                                if ( strLang === 'nb' || strLang === 'nn' ) {
                                    strLang = 'no';
                                }
                                else if ( strLang === 'se' ) {
                                    strLang = 'sv';
                                }
                                // Load validation messages from cdn, and then extend if custom messages are set.
                                e4.settings.require.jQueryValidateMessages.lang = strLang;
                                e4.settings.require.jQueryValidateMessages.url = jQuery.validator.format( e4.settings.require.jQueryValidateMessages.url, strLang );
                                e4.settings.require.jQueryValidateMessages.fallback = jQuery.validator.format( e4.settings.require.jQueryValidateMessages.fallback, strLang );
                                e4.util.require.js( e4.settings.require.jQueryValidateMessages );
                            }
                            else {
                                e4.settings.require.jQueryValidateMessages.callback();
                            }
                        },
                        setDefaults = function () {
                            //Set validation plugin default settings.
                            jQuery.validator.setDefaults( {
                                //debug: true,
                                validClass: 'is-valid',
                                errorClass: 'is-invalid',
                                highlight: function ( domElm, strClassError /*, strClassValid */ ) {
                                    jQuery( domElm ).addClass( strClassError ).closest( '.form-group' ).addClass( strClassError );
                                },
                                unhighlight: function ( domElm, strClassError /*, strClassValid */ ) {
                                    jQuery( domElm ).removeClass( strClassError ).closest( '.form-group' ).removeClass( strClassError );
                                },
                                errorPlacement: function ( jError, jElement ) {
                                    var jFormGroup         = jElement.closest( '.form-group' ),
                                        jFormValidationMsg = jFormGroup.find( '.js-e-form-validation-msg' );
                                    jError.addClass( 'form-text small invalid-feedback' );
                                    if ( jFormValidationMsg.length === 1 ) {
                                        jFormValidationMsg.replaceWith( jError );
                                    }
                                    else {
                                        jFormGroup.append( jError );
                                    }
                                },
                                focusInvalid: false,
                                invalidHandler: function ( form, validator ) {
                                    var jFirstError = jQuery( validator.invalidElements()[ 0 ] );
                                    if ( e4.util.isInViewport( jFirstError ) === true ) {
                                        validator.focusInvalid();
                                    }
                                    else {
                                        jFirstError.focus();
                                        e4.scrollToAnchor.animate( jFirstError.closest( '.form-group' ).offset().top * 0.875, e4.header.hide );
                                    }
                                },
                                submitHandler: function ( form ) {
                                    if ( jQuery( form ).is( '.js-e-form-dw' ) === true ) {
                                        //Read Dynamicweb spam script from inline script block inside the forms.
                                        e4.data.forms.dwSpamScripts[ form.id ]( form );
                                        // console.log( e4.data.forms.dwSpamScripts );
                                    }
                                    form.submit();
                                }
                            } );
                        };
                    getMessages( e4.settings.lang );
                    setDefaults();
                }
            },
            jQueryValidateMessages: {
                lang: 'en',
                test: 'window.jQuery.fn.validate.messages',
                url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/localization/messages_{0}.js',
                fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.messages_{0}.js',
                callback: function () {
                    if ( e4.settings.forms.validate.messages[ e4.settings.require.jQueryValidateMessages.lang ] !== undefined ) {
                        jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ e4.settings.require.jQueryValidateMessages.lang ] );
                    }
                    jQuery.validator.addMethod( 'localenumber', function ( value, domElm ) {
                        var regExpLocaleNumber = new RegExp( '^(?:-?\\d+|-?\\d{1,3}(?:\\' + e4.settings.separatorInteger + '\\d{3})+)?(?:\\' + e4.settings.separatorDecimal + '\\d+)?$' );
                        return this.optional( domElm ) || regExpLocaleNumber.test( value );
                    }, jQuery.validator.messages.number );
                    jQuery.validator.methods.min = function( value, element, param ) {
                        return this.optional( element ) || fku.util.formatStringToJavascriptNumber(value) >= param;
                    };
                }
            }
        }
    } );
}() );

